module.exports = __webpack_public_path__ + "img/logo.ee22d58f.png";